export const Keys = {
  Cookie: {
    Consent: 'nn-cookie-consent',
    JWT: 'Authorization',
    AppDebugPanel: 'nn-app-debug-panel',
    AppDebugEStreamRaw: 'nn-app-debug-estream-raw',
    AppDebugEStreamPanels: 'nn-app-debug-estream-panels',
    AppLog: 'nn-app-log',
  },
  Consents: {
    FirstLogin: 'FIRST_LOGIN',
    MarketTip: 'MARKET_TIP',
  },
  DebuggerVisible: 'nn-debugger-visible',
  EStreamSubscriptionSourcePrefix: 'NN-',
  Markets: {
    Mic: {
      Bet: 'XBU2',
      XetraFrankfurt: 'XETR',
      Nasdaq: 'XNAS',
      Unknown: 'XXXX',
    },
    dataProviderMicList: {
      bet: ['XBUD', 'XBU2', 'BETA', 'XTND'],
      xetraFr: ['XETR', 'XFRA'],
      xetraVie: ['XWBO'],
      london: ['XLON'],
      usa: [
        'AATS',
        'ADVT',
        'ARKX',
        'ASEF',
        'BAML',
        'BAMX',
        'BARX',
        'BBSF',
        'BGCF',
        'BHSF',
        'BIDS',
        'BKKT',
        'BLUE',
        'BNDS',
        'BNPC',
        'BNPH',
        'BNYC',
        'BPOL',
        'BSTX',
        'BTEC',
        'BTNL',
        'CALH',
        'CAST',
        'CCMX',
        'CDED',
        'CFIM',
        'CGMI',
        'CGXS',
        'CLST',
        'CMSF',
        'CODA',
        'COHR',
        'CPGX',
        'CRED',
        'DASH',
        'DBAB',
        'DEAL',
        'DWFI',
        'EDXM',
        'EGMT',
        'EQUS',
        'FAST',
        'FICO',
        'FINR',
        'FREX',
        'FSEF',
        'FTUS',
        'FXAL',
        'FXCM',
        'G1XX',
        'GFAM',
        'GLLC',
        'GLMX',
        'GLPS',
        'GLPX',
        'GOTC',
        'GOVX',
        'GREE',
        'GSCO',
        'GSEF',
        'GTCO',
        'GTSX',
        'HEGX',
        'HPPO',
        'HRTF',
        'HRTX',
        'HSFX',
        'IBKR',
        'ICEL',
        'IDXM',
        'IEXG',
        'IFUS',
        'IMCS',
        'INCR',
        'INTL',
        'ISDA',
        'ITGI',
        'JLQD',
        'JNST',
        'JPBX',
        'JPMS',
        'JPMX',
        'JSES',
        'JSJX',
        'KLSH',
        'KNIG',
        'LAMP',
        'LASF',
        'LEDG',
        'LESI',
        'LEVL',
        'LIUS',
        'LPSF',
        'LQED',
        'LTAA',
        'LTSE',
        'MEMX',
        'MIHI',
        'MSCO',
        'MTXX',
        'NBLX',
        'NFSC',
        'NMRA',
        'NODX',
        'NPMS',
        'NXUS',
        'NYPC',
        'OCEA',
        'OCTL',
        'OLLC',
        'OPRA',
        'OTCI',
        'OTCM',
        'OTCN',
        'PIPE',
        'PIPR',
        'PRSE',
        'PUMA',
        'PUND',
        'RAJA',
        'RCMA',
        'RTXF',
        'SAGE',
        'SCXO',
        'SFOX',
        'SGAS',
        'SGMA',
        'SHAW',
        'SMFE',
        'SOHO',
        'SPAX',
        'SPTX',
        'SSTX',
        'STFX',
        'STRM',
        'SUNT',
        'TERA',
        'TFSU',
        'THEM',
        'THRE',
        'TMID',
        'TPSE',
        'TRAI',
        'TRCK',
        'TRCX',
        'TRUX',
        'TRWB',
        'TSAD',
        'TSEF',
        'U360',
        'UBEC',
        'UBSA',
        'UBSS',
        'VERT',
        'VFCM',
        'VIRT',
        'VUSA',
        'WELS',
        'WSAG',
        'XAQS',
        'XBOX',
        'XCBO',
        'XCBT',
        'XCFF',
        'XCME',
        'XCUR',
        'XELX',
        'XGMX',
        'XINS',
        'XISX',
        'XMER',
        'XMGE',
        'XNAS',
        'XNYM',
        'XNYS',
        'XPUS',
        'XTRD',
        'XTXD',
        'YKNA',
      ],
    },
    Icons: {
      HU: 'hu',
      DE: 'de',
      US: 'us',
      GB: 'gb',
      EU: 'eu',
    },
  },
  Instruments: {
    Ric: {
      BUX: '.BUX',
      DAX: '.GDAXI',
      EuroStoxxIndexEur: '.SXXE',
      Nasdaq100: '.NDX',
      NasdaqComposite: '.IXIC',
      OTP: 'OTPB.BU',
      BUXZ3: 'BUXZ3',
      AAPL: 'AAPL.NB',
      MOL: 'MOLB.BU',
      MTELEKOM: 'MTEL.BU',
      RICHTER: 'GDRB.BU',
      SX18GP: '.SX18GP',
      EDE15BP: '.EDE15BP',
      STOXXE: '.STOXXE',
      EURUSD: 'EUR=',
      SX50UL: '.SX50UL',
      EURHUF: 'EURHUF=',
      TSLA: 'TSLA.NB',
      NVDA: 'NVDA.NB',
      EBS: 'ERST.VI',
    },
    Isin: {
      Unknown: 'HU0000000000',
    },
  },
  Currency: {
    /**
     * Some currency crosses are not queryable, so we need to handle them differently, but these are queryable because I've tested them manually
     *
     * DO NOT INCLUDE CASES when there is a reciprocal value. So when estream knows HUFEUR but not EURHUF we don't handle reciprocal values, so
     * the code will convert the rates into USD and then calculate the rate
     */
    ValidCurrencyCrossesAgainstEstream: ['EURHUF=', 'GBPHUF=', 'CHFHUF='],
  },
  Widgets: {
    Portfolio: {
      PriceAlert: 'Portfolio.PriceAlert',
      OpenPositions: 'Portfolio.OpenPositions',
      OpenOrders: 'Portfolio.OpenOrders',
    },
    WatchList: {
      HomePage: 'nn-watchlist-home',
      WatchListPage: 'nn-watchlist-page',
    },
    PortfolioComposition: {
      HomePage: 'nn-portfolio-composition-home',
      PortfolioCompositionPage: 'nn-portfolio-composition-page',
    },
  },
  Charts: {
    ChartPage: 'nn-chart-page',
    ChartDataCachePrefix: 'nn-chart-',
  },
  MenuState: 'nn-menu-state',
  DynamicSizing: 'nn-dynamic-sizing',
  MockedMode: 'nn-mocked-mode',
  Theme: {
    key: 'nn-theme',
    dark: 'darkTheme',
    light: 'lightTheme',
  },
  ChartTheme: {
    dark: 'ciq-night',
    light: 'ciq-day',
  },
  BroadcastChannel: {
    Atom: 'atom-channel',
  },
  NbSelect: {
    SelectAllDefaultId: 'NB_SELECT_ALL_DEFAULT_ID',
  },
  SSO: {
    scopes: [
      'userid',
      'clientid',
      'applicationid',
      'consent',
      'watchlist',
      'orderlog',
      'order',
      'subscription',
      'accountlist',
      'usersettings',
      'portfolio',
      'notification',
      'pricealertlist',
      'openid',
      'offline_access',
    ],
  },
  ErrorCode: {
    twoFactor: {
      invalidSmsCode: 'INVALID_SMS_CODE',
      orderSmsConfirmationError: 'ORDER_SMS_CONFIRMATION_ERROR',
      expiredSmsCode: 'EXPIRED_SMS_CODE',
    },
    confirmTwoFactor: {
      INVALID_SMS_CODE: 'INVALID_SMS_CODE',
      TWO_FACTOR_TRANSACTION_SET_ERROR: 'TWO_FACTOR_TRANSACTION_SET_ERROR',
      EXPIRED_SMS_CODE: 'EXPIRED_SMS_CODE',
    },
  },
  LoginError: {
    UserCancelled: 'Popup closed by user',
    AuthRequired: 'Authentication required',
    UserDisabled: 'EIH:0001',
    WrongSMSCode3Times: 'EIH:0002',
  },
  CurrencyExchange: {
    Errors: {
      DEVIZAVALTAS_NEM_ENGEDELYEZETT: 'DEVIZAVALTAS_NEM_ENGEDELYEZETT',
      DEVIZAVALTAS_ELLENORZES_IDOSZAK_NINCS: 'DEVIZAVALTAS_ELLENORZES_IDOSZAK_NINCS',
      DEVIZAVALTAS_ELLENORZES_IDOSZAK_ATLEPES: 'DEVIZAVALTAS_ELLENORZES_IDOSZAK_ATLEPES',
      DEVIZAVALTAS_JOVAHAGYAS_ERVENYTELEN_ARFOLYAM: 'DEVIZAVALTAS_JOVAHAGYAS_ERVENYTELEN_ARFOLYAM',
      DEVIZAUGYLETEK_ERVENYTELEN_ARFOLYAM: 'DEVIZAUGYLETEK_ERVENYTELEN_ARFOLYAM',
      DEVIZAVALTAS_ELLENORZES_UGYFEL_LIMIT_TULLEPES: 'DEVIZAVALTAS_ELLENORZES_UGYFEL_LIMIT_TULLEPES',
      DEVIZAVALTAS_ELLENORZES_GLOBALIS_LIMIT_TULLEPES: 'DEVIZAVALTAS_ELLENORZES_GLOBALIS_LIMIT_TULLEPES',
      TRANZAKCIO_MEGEROSITES_DEVIZAVALTAS_LIMITNEL_NAGYOBB_VALTAS:
        'TRANZAKCIO_MEGEROSITES_DEVIZAVALTAS_LIMITNEL_NAGYOBB_VALTAS',
      DEVIZAVALTAS_ELLENORZES_LIMITNEL_NAGYOBB_VALTAS: 'DEVIZAVALTAS_ELLENORZES_LIMITNEL_NAGYOBB_VALTAS',
      DEVIZAVALTAS_ELLENORZES_NYITO_ARFOLYAM_MAX_ELTERES_TULLEPES:
        'DEVIZAVALTAS_ELLENORZES_NYITO_ARFOLYAM_MAX_ELTERES_TULLEPES',
      DEVIZAVALTAS_ELLENORZES_NYITO_ARFOLYAM_HIANYZIK: 'DEVIZAVALTAS_ELLENORZES_NYITO_ARFOLYAM_HIANYZIK',
      DEVIZAVALTAS_ELLENORZES_ARFOLYAM_FRISSITES_HIBA: 'DEVIZAVALTAS_ELLENORZES_ARFOLYAM_FRISSITES_HIBA',
      PENZ_SZABAD_SZAMLAN_KISEBB_MINT_MEGBIZAS: 'PENZ_SZABAD_SZAMLAN_KISEBB_MINT_MEGBIZAS',
      PENZTAR_PENZ_SZABAD_SZAMLAN_KISEBB_MINT_MEGBIZAS: 'PENZTAR_PENZ_SZABAD_SZAMLAN_KISEBB_MINT_MEGBIZAS',
      DEVIZAVALTAS_BEFEKTETETT_OSSZEG_TULLEPES: 'DEVIZAVALTAS_BEFEKTETETT_OSSZEG_TULLEPES',
      DEVIZAVALTAS_ELLENORZES_NEM_KATEGORIZALT_HIBA: 'DEVIZAVALTAS_ELLENORZES_NEM_KATEGORIZALT_HIBA',
      DEVIZAVALTAS_VETEL_DARABSZAM_MINIMUM_EGY: 'DEVIZAVALTAS_VETEL_DARABSZAM_MINIMUM_EGY',
      DEVIZAVALTAS_ELADAS_DARABSZAM_MINIMUM_EGY: 'DEVIZAVALTAS_ELADAS_DARABSZAM_MINIMUM_EGY',
      DEVIZAVALTAS_VETEL_DARABSZAM_MINIMUM_EGY_ERROR: 'DEVIZAVALTAS_VETEL_DARABSZAM_MINIMUM_EGY_ERROR',
      DEVIZAVALTAS_ELADAS_DARABSZAM_MINIMUM_EGY_ERROR: 'DEVIZAVALTAS_ELADAS_DARABSZAM_MINIMUM_EGY_ERROR',
      DEVIZAVALTAS_500: '500',
    },
  },
  CashAction: {
    Errors: {
      NETBANKBROKER_ATVEZETES_NINCS_FORRAS_SZAMLA: 'NETBANKBROKER_ATVEZETES_NINCS_FORRAS_SZAMLA',
      ATVEZETES_FORRAS_SZAMLA_NEM_VALID_IDOSZAK: 'ATVEZETES_FORRAS_SZAMLA_NEM_VALID_IDOSZAK',
      EXPIRED_SMS_MSG: 'SMS kód érvényessége lejárt. Próbáld újra.',
    },
  },
};
